(function ($) {
  $(document).ready(function () {
    $(".card-content-with-image-slider .slider-wrap").slick({
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: false,
    });
  });
})(jQuery);
